export default {
  ApiErrors: {
    generic: 'אירעה שגיאה. אנא רעננו את הדף וצרו איתנו קשר אם הבעיה נמשכת.',
    'Email already exists': 'האימייל כבר קיים',
    'This field is required.': 'שדה זה נדרש',
    'First_name must be filled': 'יש למלא שם פרטי',
    'Password length must be over 8 characters': 'אורך הסיסמה חייב להיות מעל 8 תווים',
    'Unable to login with the provided credentials': 'לא ניתן להתחבר עם האישורים שסופקו',
    'godson is already a customer': 'אימייל זה שייך ללקוח קיים',
    'godson is in referral process': 'אימייל זה כבר בתהליך הפניה',
    'Enter a valid email address': 'אנא הזן כתובת אימייל חוקית',
    'Email already in db': 'האימייל כבר קיים',
    'Not an email': 'האימייל אינו חוקי',
    'Reward is soldout': 'הפרס אזל מהמלאי',
    'Reward can only be claimed once': 'כבר מימשת פרס זה',
    'Reward is no longer valid': 'הפרס אינו בתוקף',
    'Not enough points': 'אין מספיק נקודות',
    'Account already in use': 'חשבון זה כבר בשימוש על ידי משתמש אחר',
    'This instagram account does not exist on Instagram': 'חשבון אינסטגרם זה לא קיים',
    'social error': "אנא הזן את חשבונך {'@'}username",
    'required field': 'אנא מלא שדה זה',
    'value error': 'הערך שהוזן אינו תקין',
    'You already applied a discount code': 'כבר השתמשת בקוד הנחה'
  },
  Error: {
    generic: 'אירעה שגיאה. אנא רעננו את הדף.',
    link: 'רענן את הדף',
    title: 'Loyoly - אופס! שגיאה',
    blacklistMessage1: 'אינך זכאי לתוכנית הנאמנות.',
    blacklistMessage2: 'צרו קשר עם צוות התמיכה אם לדעתכם מדובר בטעות.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'אנא הזן כתובת אימייל חוקית',
      emailEmpty: 'אנא הזן את כתובת האימייל שלך'
    }
  },
  InApp: {
    message: 'כדי לקבל חווית משתמש מיטבית, היכנסו דרך הדפדפן המוגדר כברירת מחדל'
  },
  Phone: {
    countrySelector: {
      placeholder: 'קוד מדינה',
      error: 'בחרו מדינה',
      searchPlaceholder: 'בחרו מדינה'
    },
    phoneInput: {
      placeholder: 'מספר טלפון',
      example: 'דוגמה:'
    },
    error: {
      invalid: 'אנא הזן מספר טלפון חוקי'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'חיבור לחשבון האינסטגרם שלי',
      subtitle: 'איך זה עובד',
      description: 'אנא הזן את חשבון האינסטגרם שלך וודא שהוא ציבורי לפני ביצוע המשימות.',
      form: {
        username: 'חשבון אינסטגרם',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'אנא הזן את שם המשתמש שלך',
        usernameNotFound: 'אנא הזן שם משתמש תקין'
      },
      button: 'אשר'
    },
    ModalSearching: {
      title: 'אנחנו מחפשים את החשבון שלך'
    },
    ModalLinked: {
      title: 'חיבור לחשבון האינסטגרם שלי',
      private: {
        subtitle: 'לא ניתן להתחבר עם החשבון שלך',
        description: {
          title: 'החשבון שלך פרטי',
          text: 'נראה שהחשבון שלך הוא פרטי. הפוך אותו לציבורי כדי שתוכל לבצע משימות.'
        }
      },
      public: {
        subtitle: 'החיבור לחשבונך הצליח',
        description: {
          title: 'ברכותינו',
          text: 'תוכל כעת לבצע משימות.'
        }
      },
      buttons: {
        edit: 'ערוך את החשבון שלי',
        retry: 'נסה שוב',
        goback: 'חזור לעמוד',
        gotoChallenge: 'גש למשימה'
      }
    },
    ModalNotFound: {
      title: 'חיבור לחשבון האינסטגרם שלי',
      subtitle: 'לא ניתן להתחבר לחשבון שלך',
      description: {
        title: 'לא ניתן למצוא את החשבון',
        text: 'אנו מזמינים אותך להחליף חשבון או ליצור בקשה לתמיכה.'
      },
      buttons: {
        change: 'שנה חשבון',
        retry: 'נסה שוב'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'התראות בדוא"ל',
      information: {
        title: 'מידע',
        text: 'אם אינך מעוניין לקבל תזכורות למשימות, עדכונים או תזכורות לפרסים, תוכל לבטל את ההרשמה על ידי ביטול הסימון בתיבות למטה:'
      },
      communication: {
        optinTransactional: 'פרסומי: מידע על התוכנית, רמות VIP, פרסים.',
        optinMarketing: 'מידעי: מידע על רכישות והפניות.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'חשבון ציבורי',
        private: 'חשבון פרטי',
        followers: '<span class="weglot-ignore">{n}</span> עוקב | <span class="weglot-ignore">{n}</span> עוקבים'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> נקודה | <span class="weglot-ignore">{n}</span> נקודות',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> נקודה | <span class="weglot-ignore">{value}</span> נקודות',
  SectionHeader: {
    poweredBy: 'מופעל על ידי'
  },
  SectionChallenges: {
    empty: 'אין משימות זמינות בתוכנית הנאמנות שלך',
    showAll: 'הצג הכל',
    ModalMissionDetail: {
      description: 'תיאור',
      pointsToEarn: 'נקודות להרוויח',
      howto: 'איך זה עובד?',
      uploadMedia: 'העלה מדיה',
      reviewApplication: 'כתיבת ביקורת',
      linkApplication: 'הורד את האפליקציה',
      newsletterPartners: 'בלחיצה על "אשר משימה", אתה מסכים לקבל הצעות מסחריות מחברתנו באופן אלקטרוני.',
      phonePartners: 'אני מסכים שהמספר שלי ישמש לקבלת הצעות ב-SMS.',
      clue: 'רמז',
      linkPage: 'צפה בעמוד',
      instaMention: 'תייגו',
      tiktokMention: 'תייגו',
      instaHashtags: 'האשטאג(ים) לשימוש',
      tiktokHashtags: 'האשטאג(ים) לשימוש',
      linkToShare: 'קישור לשיתוף בסטורי',
      linkShare: 'קישור לשיתוף',
      vouchertoShare: 'קוד קידום לשיתוף',
      goToAccount: 'גש לחשבון',
      goToInsta: 'גש לחשבון',
      goToInstaPost: 'גש לפוסט באינסטגרם',
      goToInstaReel: 'גש לריל באינסטגרם',
      goToInstaIGTV: 'גש ל-IGTV באינסטגרם',
      goToTweeterTweet: 'גש לציוץ בטוויטר',
      goToReview: 'השאר ביקורת',
      goToShop: 'גש לחנות',
      goToLink: 'גש לעמוד',
      goToTypeform: 'מלא את הטופס',
      goToWhatsapp: 'הצטרף לקבוצה',
      submit: 'אשר משימה',
      missionPendingTitle: 'משימה בתהליך בדיקה',
      missionPendingExplain: 'הנקודות שלך יזוכו בקרוב.',
      actionSurveyTextError: 'אנא בחר תשובה',
      actionEmailError: 'האימייל שלך אינו חוקי',
      actionInputError: 'שדה זה אינו תקין',
      actionInputImageError: 'אנא העלה את המדיה שלך',
      handlingMedia: 'מעבד את המדיה',
      errorMediaHandle: 'אירעה שגיאה בעת עיבוד המדיה שלך',
      imageInvalid: 'אירעה שגיאה בעת עיבוד המדיה שלך',
      videoSize: 'גודל הסרטון חייב להיות קטן מ-100 מגהבייט.',
      errorInstaReel: 'כתובת הריל אינה תקינה',
      'This url is not a valid google url': 'כתובת הביקורת בגוגל אינה חוקית',
      'This url is not a valid reel url': 'כתובת הריל אינה תקינה',
      refusalReasonCondition: 'אי עמידה בתנאים',
      refusalReasonQuality: 'איכות נמוכה מדי',
      refusalReasonContent: 'תוכן בלתי הולם',
      refusalReasonSound: 'צליל בלתי ברור',
      missionInvalidTitle: 'המשימה נדחתה',
      missionInvalidDescription: 'תוכל לבצע את המשימה שוב תוך הקפדה על התנאים הנדרשים',
      missionInvalidReasons: 'סיבת הדחייה:',
      condition: 'תנאים',
      conditionExplanation: 'יש צורך בלמעלה מ',
      ineligible: 'לא זכאי',
      ineligibleExplanation:
        'נראה שאין לך את מספר העוקבים הנדרש. אם יש לך יותר עוקבים, אנו מזמינים אותך לעדכן את פרטי החשבון שלך.',
      lastUpdate: 'עודכן לאחרונה בתאריך',
      updateAccount: 'עדכן את החשבון שלי',
      reviewLastPurchase: 'השאר ביקורת על המוצר שרכשת לאחרונה',
      whenReviewValidated: 'ברגע שהביקורת תאושר, המשימה תאושר באופן אוטומטי',
      pointsToEarnPhoto: 'נקודות נוספות על העלאת תמונה',
      pointsToEarnVideo: 'נקודות נוספות על העלאת סרטון',
      howtoBirthdate: 'הכנס את תאריך הלידה שלך',
      errorInvalidDate: 'אנא הזן תאריך חוקי',
      inputMedia: 'העלה את המדיה שלך',
      inputMediaLoaded: 'המדיה שלך הועלתה בהצלחה',
      placeholderAnswer: 'כתוב את תשובתך כאן',
      misteryAnswer: 'מהי מילת התעלומה?',
      newsletterEmail: 'אשר את כתובת האימייל שלך',
      birthDate: 'תאריך לידה',
      example: 'דוגמה',
      goToChallenge: 'לעבור למשימה'
    },
    ModalMissionImageRights: {
      imageRights:
        'באמצעות סימון תיבה זו, אני מאשר/ת כי אני יוצר/ת התוכן, מסכים/מה במפורש להעברת זכויות הקניין הרוחני הקשורות אליו, ומתיר/ה למותג לעשות שימוש מסחרי בדמותי בהתאם לתנאים וההגבלות המפורטים ב',
      imageRightsLink: 'הסכם זה.',
      title: 'הסכם להעברת זכויות קניין רוחני על התוכן ואישור לניצול מאפייני האישיות שלי.',
      content: 'אני מאשר/ת במפורש כי פרסום התוכן שנוצר במסגרת המשימה שלי (להלן: "התוכן"):',
      bullet1:
        'מהווה העברת כל זכויות היוצרים הקשורות לתוכן למותג, באופן מלא, עולמי, ולמשך כל תקופת ההגנה המשפטית על זכויות היוצרים, באופן בלעדי וסופי. אני מכיר/ה בכך שהעברה זו ניתנת בתמורה לנקודות שצברתי במסגרת המשימה שלי, ומהוות תמורה הולמת. ההעברה כוללת את זכות ההעתקה וההצגה של התוכן, כולו או חלקו, על גבי כל מדיה ובכל אמצעי, קיים או עתידי, צפוי או בלתי צפוי, וכן את הזכות לתרגם, לשנות, להתאים ולערוך את התוכן על ידי המותג, לבדו או בשיתוף עם צד שלישי. אני מתחייב/ת שהתוכן לא יפגע בזכויות צדדים שלישיים ולא יהווה הפרת זכויות יוצרים, ומתחייב/ת לשפות את המותג במקרה הצורך;',
      bullet2:
        'מהווה מתן אישור למותג, ללא תמורה, לקבע, לשכפל, להפיץ ולפרסם את מאפייני האישיות שלי הקשורים לתוכן, בכל מדיה ובכל אמצעי קיים או עתידי, צפוי או בלתי צפוי, בכל פלטפורמה, רשת או ערוץ הפצה, לצורכי ניצול, מידע, תקשורת, קידום ופרסום של מוצרי המותג, למשך 10 שנים, עם אפשרות להארכה בהסכמה הדדית.',
      end1: 'הסכם זה כפוף לחוק הצרפתי ויפורש בהתאם לו.',
      end2: 'כל מחלוקת בנוגע לתוקפו, פרשנותו או ביצועו תובא לסמכות השיפוט הבלעדית של בתי המשפט בפריז, אלא אם נקבע אחרת לפי הדין הפרוצדורלי.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        'נקודה <span class="weglot-ignore">{points}</span> תצבור עבור כל <span class="weglot-ignore">{amountToPoints}</span> שתוציא | <span class="weglot-ignore">{points}</span> נקודות שתרוויח על כל <span class="weglot-ignore">{amountToPoints}</span> שתוציא',
      orderNumber: 'מספר הזמנה',
      orderDate: 'תאריך הזמנה',
      orderAmount: 'סכום',
      orderRewardable: 'כפוף לפרס',
      orderPoints: 'נקודות שהורווחו',
      orderPaid: 'אושר',
      orderStatus: 'סטטוס',
      orderCancel: 'בוטל',
      orderRefund: 'הוחזר חלקית',
      orderWaiting: 'ממתין'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'הצג את תנאי השימוש',
      seePrivacy: 'הצג את מדיניות הפרטיות'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'חיבור לאינסטגרם',
      tiktok: 'חיבור לטיקטוק'
    },
    notificationsByEmails: 'התראות באמצעות אימיילים',
    cgu: 'תנאי שימוש'
  },
  SectionAccountRewards: {
    empty: 'אין יותר פרסים זמינים להחלפה ואין לך פרסים שממתינים לשימוש',
    copied: 'הועתק!'
  },
  SectionRewards: {
    empty: 'אין פרסים זמינים בתוכנית הנאמנות שלך',
    showAll: 'הצג הכל',
    Card: {
      channel_store: 'בחנות',
      channel_online: 'באינטרנט',
      channel_both: 'באינטרנט ובחנות'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'הפרסים שלי',
    empty: 'אין לך עדיין פרסים.',
    emptyTip: 'תוכל לבצע משימות ולהחליף את הנקודות שצברת בפרסים',
    use: 'השתמש',
    expired: 'פג תוקף'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'תאריך תפוגה',
    expirationDelayExplain:
      'הפרס יהיה זמין לשימוש במשך <span class="weglot-ignore">{expiration_delay}</span> ימים לאחר החלפה.',
    minimumBuy: 'מינימום רכישה',
    maxAmount: 'בתוקף עד',
    description: 'תיאור',
    saleChannel: 'ערוץ מכירה',
    channelStore: 'בחנות',
    channelOnline: 'באינטרנט',
    channelBoth: 'באינטרנט ובחנות'
  },
  SectionRewardsDetailModal: {
    exchange: 'החלף',
    errorMessage1: 'נראה שקרתה בעיה.',
    errorMessage2: 'הפרס שלך לא הוחלף והנקודות שלך לא נגרעו.',
    errorMessage3: 'אנא רענן את העמוד.',
    errorButton: 'רענן את העמוד'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'איך זה עובד?',
    howItWorkCode: 'השתמש בקוד שלך באתר שלנו בעת ביצוע ההזמנה',
    howItWorkCodeProduct: 'הוסף את המוצר לעגלה שלך ולאחר מכן השתמש בקוד שלך בעת ביצוע ההזמנה',
    howItWorkCodeRecharge: 'הוסף את הקוד ישירות בפורטל הלקוחות שלך',
    howItWorkExt: 'תיצור קשר כדי לקבל את הפרס שלך',
    applyToBasket: 'החל על העגלה',
    apply: 'החל',
    applied: 'הוחל',
    link: 'קישור למוצר',
    copied: 'הועתק!',
    customerPortal: 'פורטל לקוחות',
    nonApplicable: 'לא זכאי'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'החל',
    nonApplicable: 'לא זכאי',
    itemTitle: '{title} / {price}',
    customerPortal: 'פורטל לקוחות'
  },
  SectionReferral: {
    friendEmail: 'אימייל של החבר שלך',
    seeReferral: 'ראה את ההפניות שלי',
    errors: {
      emailSelf: 'האימייל שהוזן זהה לאימייל שלך'
    },
    Tabs: {
      link: 'קישור',
      email: 'אימייל',
      sms: 'SMS',
      copy: 'העתק קישור',
      smsSend: 'שלח הודעה',
      reward1: '{amount} נקודות',
      reward2: '{amount}% הנחה',
      reward3: 'שובר קנייה בשווי {amount}',
      smsTemplate:
        'שלום! מצאתי את {brand_name} ואולי תאהב את זה.\n\n בשימוש בקישור ההפניה שלי {referral_link}, תוכל לקבל {reward_friend}.\n\nתיהנה מההצעה! נתראה!'
    },
    Modal: {
      emptyState: 'לא ביצעת עדיין הפניות',
      title: 'ההפניות שלי',
      status: 'סטטוס',
      email: 'אימייל',
      date: 'תאריך תפוגה',
      statusPending: 'בהמתנה',
      statusUsed: 'כבר בשימוש',
      statusAvailable: 'זמין',
      statusExpired: 'פג תוקף',
      statusInvalidate: 'בוטל',
      promocodeComing: 'בקרוב',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'בוטל',
      points_given: 'הנקודות שלך זוכו',
      referral_type_3: 'שובר קנייה',
      referral_type_2: 'קוד קידום',
      referral_type_1: 'נקודות'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'אימייל',
      emailError: 'פורמט האימייל אינו תקין',
      emailEmpty: 'אנא מלא שדה זה',
      emailUnknown: 'אנא צור חשבון כדי שתוכל להפנות'
    }
  },
  SectionVipTiersProgress: {
    you: 'אתה',
    points: 'נקודות'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} נקודות בונוס',
    rewardMultiplier: 'כפול נקודות: x{multiplier}',

    tiersPoints: '{amount} נקודות'
  },
  SectionGifting: {
    empty: 'אין כרגע מוצרים זמינים לניסיון',
    showAll: 'הצג הכל',
    ModalApply: {
      endDate: 'תאריך סיום ההגשות',
      description: 'תיאור',
      completeForm: 'מלא את הטופס כדי להגיש מועמדות',
      button: 'הגש מועמדות',
      success: {
        title: 'רישום לניסיון מוצר',
        description: 'תודה שהשלמת את המידע שלך. בקשתך בבדיקה. תעודכן באימייל.'
      },
      Form: {
        Errors: {
          required: 'אנא מלא שדה זה',
          date: 'אנא הזן תאריך חוקי'
        }
      }
    },
    ModalParticipate: {
      challenges: 'משימות',
      howItWorks: 'איך זה עובד?',
      useCode: 'השתמש בקוד שלך באתר שלנו בעת ביצוע ההזמנה.',
      youWillBeContacted: 'תיצור קשר כדי לקבל את המוצר שלך.',
      buttonLink: 'קישור למוצר',
      buttonCopied: 'הועתק!'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} חודש | {n} חודשים'
    },
    ModalActivities: {
      title: 'הפעילויות האחרונות שלי',
      empty: 'עדיין אין לך פעילויות אחרונות.',
      table: {
        header: {
          title: 'כותרת',
          points: 'נקודות',
          date: 'תאריך'
        }
      },
      events: {
        challenge: 'משימה הושלמה',
        order: 'רכישה בוצעה',
        reward: 'פרס התקבל',
        refferal: 'הפניה הושלמה',
        userAction: 'נקודות הותאמו',
        level: 'רמה הושגה',
        levelLabel: 'רמה {level}',
        reset: 'תוקף הנקודות פג',
        automation: 'נקודות שהורווחו'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'חיבור לחשבון ה-TikTok שלי',
      subtitle: 'איך זה עובד',
      description: 'אנא הזן את חשבון ה-TikTok שלך וודא שהוא ציבורי. לאחר מכן תוכל לבצע משימות ב-TikTok.',
      button: 'חבר את החשבון שלי'
    },
    ModalLinked: {
      title: 'חיבור לחשבון ה-TikTok שלי',
      subtitle: 'החיבור לחשבונך הצליח',
      congratulations: 'ברכותינו',
      description: 'תוכל כעת לבצע משימות TikTok.',
      buttons: {
        edit: 'ערוך את החשבון שלי',
        goback: 'חזור לעמוד'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'כתובת אימייל',
    emailError: 'אנא הזן כתובת אימייל חוקית',
    emailEmpty: 'אנא הזן את כתובת האימייל שלך',
    disclaimer: 'ההצעה זמינה רק ללקוחות חדשים',
    disclaimerVerification: 'לא תיצור קשר למטרות מסחריות.',
    referral_type_3: 'שובר קנייה',
    referral_type_2: 'קוד קידום',
    referral_type_1: 'נקודות',
    copied: 'הועתק!',
    label_optin_reminder: 'אני רוצה לקבל תזכורת אם אני לא משתמש בהנחה שלי.',
    btn_optin_reminder: 'קבל תזכורת על הקוד שלי'
  },
  Unsubscribe: {
    title: 'האם אתה בטוח שברצונך להפסיק לקבל מיילים מתוכנית הנאמנות שלנו?',
    description: 'אם כן, אנא שים לב שלא תוכל עוד לקבל מידע על הפרסים, המשימות והנקודות שלך.',
    email: 'אימייל',
    button: 'עדכן את ההעדפות שלי',
    question: 'איזה סוג מיילים תרצה להמשיך לקבל:',
    optinTransactional: 'פרסומי: מידע על התוכנית, רמות VIP, פרסים.',
    optinMarketing: 'מידעי: מידע על רכישות והפניות.',
    successTitle: 'העדפותיך עודכנו בהצלחה',
    successDescription: 'השתמש בכפתור למטה כדי לעיין או לשנות את העדפותיך',
    successButton: 'עדכן את ההעדפות שלי',
    errorTitle: 'אירעה שגיאה עם קישור ההפניה',
    errorButton: 'חזור לאתר'
  },
  SectionAccount: {
    copied: 'הועתק!'
  },
  SectionPointCard: {
    you: 'אתה',
    copied: 'הועתק!'
  }
}
